import React, { useState, useEffect } from 'react';
import LogoImage from '../../../assets/images/mpower-logo.png';
import './PatientLogin.scss';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import { getReferenceId,patientLogin } from '../../../../../shared/src/services/PatientDocumentUpload';
import AuthUtils from '../../../utils/AuthUtils';
import NavRoutes from '../../../constants/NavRoutes';
import InitSharedRepo from '../../../../../shared';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { _logout,_patientLogin, _patientInfo,_snackbarAcknowledgement,_loginError } from '../../../../../shared/src/store/actions/AuthActions';
import { PATIENT_BASE_ROUTE } from '../../../constants/BaseRoute';
import { useTranslation } from 'react-i18next';
import AppLoader from '../../../components/apploader/AppLoader';
import PatientLoginError from './PatientLoginError';
const PatientLogin = (props: any): JSX.Element => {
  const { t } = useTranslation();
  const [enteredOTP, setEnteredOTP] = useState('');
  const [isResendButtonDisabled, setIsResendButtonDisabled] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [timer, setTimer] = useState(0);
  const [errorLoader,setErrorLoader] = useState(false);
const [referenceId,setReferenceId] = useState<number>(0);
  const [phoneNumber,setPhoneNumber] = useState();
  const { code } = useParams<{ code: string }>();
  const dispatch =  useDispatch()

  const sendOtp = async()=>{
    try{
      setIsLoading(true);
      const response = await getReferenceId(code);
      setIsLoading(false);
      setReferenceId(response.data.reference_id);
      setPhoneNumber(response.data.phone_number);
    }
    catch(error){
      setErrorLoader(true)
      const err = error as any;
      if (err) {
        if (err.response && err.response.status === 400) {
          props.history.push(`/${PATIENT_BASE_ROUTE}/${NavRoutes.PUBLIC.PATIENT_LOGIN_ERROR}`)
          dispatch(_loginError(err.response.data.error.message))
          dispatch(_snackbarAcknowledgement(true, err.response.data.error.message, 'error'))
        } else {
          setIsLoading(false);
          dispatch(_snackbarAcknowledgement(true, t('error_messages.default'), 'error'))
        }
      }
    }
    finally{
      setIsLoading(false);
      setErrorLoader(false)
    }
  }

  useEffect(()=>{
    AuthUtils.clearAuthToken();
    AuthUtils.clearUser();
    AuthUtils.clearUserType();
    dispatch(_logout());
    if (!referenceId) {
      sendOtp();
    }
  },[]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    let interval: any;
    if (timer > 0) {
      interval = setInterval(() => {
        setTimer(timer - 1);
      }, 1000);
    } else {
      setIsResendButtonDisabled(false);
    }
    return () => clearInterval(interval);
  }, [timer]);

  const handleSubmit = async () => {
    try {
      AuthUtils.clearAuthToken();
      const response = await patientLogin(Number(enteredOTP), referenceId);
      InitSharedRepo.initAfterPatientAuth(response.data.token);
      AuthUtils.setPatientAuthToken(response.data.token);
      setEnteredOTP('');
      dispatch(_patientLogin(response.data.token,undefined,undefined))
      // Navigate to the documents upload page on success
      props.history.push(`/${PATIENT_BASE_ROUTE}/${NavRoutes.PRIVATE.PATIENT.DOCUMENTS}/${NavRoutes.PRIVATE.PATIENT.UPLOAD_CARDS}`);
      const { first_name: firstName , last_name:lastName, dos, surgeon, patient_id:patientId } = response.data.data;
      dispatch(_patientInfo(firstName,lastName,dos,surgeon,patientId))
    } catch (error) {
      const err = error as any;
      if(err){
        if(err.response && err.response.status === 400){
          dispatch(_snackbarAcknowledgement(true,err.response.data.error.message, 'error'))
        } else {
          dispatch(_snackbarAcknowledgement(true,err.message, 'error'))
        }
      }
    }
  };

  const handleResendOTP = async() => {
    // Implement the logic to resend the OTP
    await sendOtp();
    setIsResendButtonDisabled(true);
    setTimer(30);
    setEnteredOTP('');
    // Reset the entered OTP
  };

  return isLoading ? (<AppLoader />) : errorLoader ? (<PatientLoginError />):(
    <div className="patient-portal-login-wrapper">
      <div className="logo-wrapper">
        <img src={LogoImage} />
      </div>
      <p className="one-time-password-text">{t('PATIENT_DOCUMENT_UPLOAD.OTP')}</p>
      <p className='helper-text'>{t('PATIENT_DOCUMENT_UPLOAD.OPTSENT')} <span className='phone-number'>{phoneNumber}</span></p>
      {/* TODO: Should the text be center aligned in the below input */}
      <TextField
        variant="outlined"
        placeholder={'......'}
        fullWidth
        inputProps={{
          maxLength: 6,
          type:'number',
          onInput: (e) => {
            const input = e.target as HTMLInputElement;
            if (input.value.length > 6) {
              input.value = input.value.slice(0, 6);
            }
          },
        }}
        className={'otp-input-field'}
        onChange={(e) => {
          setEnteredOTP(e.target.value)
        }}
      />
      <div className='reset-button-container'>
        <Button
          className="resend-button"
          variant="contained"
          color="primary"
          disableRipple
          disabled={isResendButtonDisabled}
          onClick={handleResendOTP}
        >
          {timer > 0 ? `${t('PATIENT_DOCUMENT_UPLOAD.RESENDOTP')} (${timer})` : `${t('PATIENT_DOCUMENT_UPLOAD.RESENDOTP')}`}
        </Button>
      </div>
      <Button
        className="submit-button"
        variant="contained"
        color="primary"
        disableRipple
        fullWidth
        disabled={enteredOTP.length < 6}
        onClick={handleSubmit}>
        {t('COMMON.SUBMIT')}
      </Button>
    </div>
  );
};

export default PatientLogin;